import formStyles from 'legacy/common/components/form/Form.module.scss';
import { useState } from 'react';
import { MdArrowBack, MdLockOutline } from 'react-icons/md';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import FadeIn from 'legacy/common/components/transition/FadeIn';

type PrivateCodeForm = {
  title: string;
  isLoading: boolean;
  errorMessage: string;
  onGoBack: () => void;
  onUnlock: (code: string) => void;
};

const PrivateCodeForm = ({
  title,
  errorMessage,
  isLoading,
  onUnlock,
  onGoBack
}) => {
  const [privateCode, setPrivateCode] = useState('');

  return (
    <FadeIn>
      <div className="mt-10 relative px-8">
        <MdArrowBack
          size="26px"
          className="absolute -top-16 left-0 text-gray-500"
          onClick={onGoBack}
        />
        <div className="flex mt-10 md:mt-0">
          <MdLockOutline size="20px" />
          <div className="ml-2">
            <div className="text-gray-600 text-lg">
              {title || 'Enter Private Code'}
            </div>
            <div className="mt-1 mb-5 text-gray-400 font-normal">
              Unlock a special code
            </div>
          </div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onUnlock(privateCode);
          }}
        >
          <input
            type="text"
            onChange={(e) => setPrivateCode(e.target.value.trim())}
            data-testid="code-input"
            className={formStyles.input}
          />
          <div className="mt-5">
            <Button
              isSubmit
              disabled={!privateCode}
              loading={isLoading}
              testId="button-unlock"
              type={ButtonType.Primary}
            >
              Unlock
            </Button>
          </div>
          <div className={formStyles.error}>{errorMessage}</div>
        </form>
      </div>
    </FadeIn>
  );
};

export default PrivateCodeForm;
